The type representing a previously selected response for a library question when retrieving a draft.
